/**
 * MenuFlutuante — dropdown com position:fixed ancorado ao botao que o abriu,
 * renderizado via PORTAL em document.body.
 *
 * Por que portal + fixed:
 * - os cards (.task) tem overflow:hidden e o modal (.tm__aside/.tm__main)
 *   overflow-y:auto — menu absolute dentro deles e CORTADO na borda;
 * - o modal (.tm) mantem `transform` (animacao de abertura), e um ancestral
 *   com transform vira o containing block de position:fixed — o menu abriria
 *   DESLOCADO. O portal tira o menu da arvore do modal; como o tema
 *   ([data-theme]) vive no <html>, o menu portalado herda o dark mode normal.
 *
 * Uso:
 *   const [pos, setPos] = useState(null);
 *   onClick={(e) => setPos(pos ? null : ancorarMenu(e))}
 *   <MenuFlutuante pos={pos} onClose={() => setPos(null)}>…opcoes…</MenuFlutuante>
 */
import React from "react";
import { createPortal } from "react-dom";

// Calcula a posicao do menu a partir do botao clicado (alinhado a direita).
// clientWidth (nao innerWidth): o CSS `right` de um fixed e medido a partir da
// viewport SEM a scrollbar — innerWidth a inclui e deslocaria o menu ~17px.
export function ancorarMenu(evento) {
  const r = evento.currentTarget.getBoundingClientRect();
  const larguraViewport =
    document.documentElement.clientWidth || window.innerWidth;
  return {
    top: r.bottom + 6,
    right: Math.max(8, larguraViewport - r.right),
  };
}

export default function MenuFlutuante({ pos, onClose, children, style }) {
  if (!pos) return null;
  return createPortal(
    <>
      <div
        style={{ position: "fixed", inset: 0, zIndex: 129 }}
        onMouseDown={onClose}
      />
      <div
        className="tm-status-menu pend-menu-flutuante"
        role="menu"
        style={{
          position: "fixed",
          top: pos.top,
          right: pos.right,
          left: "auto",
          zIndex: 130,
          ...style,
        }}
      >
        {children}
      </div>
    </>,
    document.body
  );
}
